import { render, staticRenderFns } from "./EventsDetail.vue?vue&type=template&id=950c7ee4&scoped=true"
import script from "./EventsDetail.vue?vue&type=script&lang=js"
export * from "./EventsDetail.vue?vue&type=script&lang=js"
import style0 from "./EventsDetail.vue?vue&type=style&index=0&id=950c7ee4&prod&lang=scss&scoped=true"
import style1 from "./EventsDetail.vue?vue&type=style&index=1&id=950c7ee4&prod&lang=scss"
import style2 from "./EventsDetail.vue?vue&type=style&index=2&id=950c7ee4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950c7ee4",
  null
  
)

export default component.exports